var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { constants } from "../../styles";
import Text from "../Text";
import { Label, Input, Check } from "./style";

var Radio = function Radio(_ref) {
  var children = _ref.children,
      block = _ref.block,
      validate = _ref.validate,
      size = _ref.size,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["children", "block", "validate", "size", "style"]);

  return React.createElement(
    Label,
    { block: block, style: style, validate: validate, size: size },
    React.createElement(Input, _extends({ type: "radio", validate: validate, size: size }, props)),
    React.createElement(Check, { "data-radio": "check", validate: validate, size: size }),
    children && React.createElement(
      Text,
      { size: size, noMargin: true, style: { marginLeft: 10 } },
      children
    )
  );
};

var _constants$sizes = constants.sizes,
    SM = _constants$sizes.SM,
    MD = _constants$sizes.MD,
    LG = _constants$sizes.LG;
var _constants$colors = constants.colors,
    DANGER = _constants$colors.DANGER,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING;


Radio.propTypes = {
  children: PropTypes.node,
  /**
   * Change display to block
   */
  block: PropTypes.bool,
  /**
   * Size of the field. Use sm, md, or lg values.
   */
  size: PropTypes.oneOf([SM, MD, LG]),
  /**
   * Color of the field. Use success, warning, or danger values.
   */
  validate: PropTypes.oneOf([null, SUCCESS, WARNING, DANGER])
};

Radio.defaultProps = {
  children: "",
  block: false,
  size: MD,
  validate: null
};

export default Radio;